import { Injectable } from '@angular/core';
import { RequestConfigImplementation, REQUEST_METHODS, HTTPWrapperContext, XHR_STRATEGIES, AxwayTokenFetcherService } from '@ptl/xhr';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ProducerStateStructure } from 'src/app/angular-elements/producer/configs/interfaces/producerStateStructure.interface';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME } from '@ptl/account-management';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DocumentOrderRequestPayload } from '../interfaces/doc-order-form.interface';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';

@Injectable({
    providedIn: 'root'
})
export class DocumentOrderFormService {

    constructor(
        private httpClient: HTTPWrapperContext,
        private axwayTokenFetcherService: AxwayTokenFetcherService
    ) { }

    submitDocumentRequest(payload: DocumentOrderRequestPayload): Promise<any> {
        const host = window.location.hostname;
        let env = '';
        if (host.indexOf('env') >= 0) 
            env = 't' + host.substring(host.indexOf('env'), host.indexOf('.'));
        
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.REPORTS.PROVIDER_DIRECTORY_REPORT, {}),
            responseType: 'text',
            POST_OR_PUT_PAYLOAD: {
                payload
            },
            headers: new HttpHeaders({
                'x-hmhs-test-backend': `wasinter${env}.highmark.com`
            })
        });

        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
        return this.httpClient.makeRequest(requestConfig);
    }
    
}
